import type { Router } from 'vue-router';

const RELOAD_MARKER = 'stale-chunk-reload-at';
const RELOAD_DEBOUNCE_MS = 10_000;

function isModuleImportError(error: unknown): boolean {
  if (!error) return false;
  const message = (error as { message?: string }).message ?? '';
  const name = (error as { name?: string }).name ?? '';
  return (
    message.includes('Importing a module script failed') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    /Loading chunk \S+ failed/i.test(message) ||
    /Loading CSS chunk \S+ failed/i.test(message) ||
    name === 'ChunkLoadError'
  );
}

function reloadTo(href: string): void {
  const now = Date.now();
  const last = Number(sessionStorage.getItem(RELOAD_MARKER) || 0);
  if (now - last < RELOAD_DEBOUNCE_MS) return;
  sessionStorage.setItem(RELOAD_MARKER, String(now));
  window.location.replace(href);
}

export function installStaleChunkReload(router: Router): void {
  router.onError((error, to) => {
    if (!isModuleImportError(error)) return;
    reloadTo(to?.fullPath || window.location.pathname + window.location.search);
  });

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadTo(window.location.href);
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isModuleImportError(event.reason)) return;
    event.preventDefault();
    reloadTo(window.location.href);
  });
}
